/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ExecutionDaySetting } from '../models';
// @ts-ignore
import { GetExecutionDaySetting200Response } from '../models';
/**
 * ExecutionDaySettingApi - axios parameter creator
 * @export
 */
export const ExecutionDaySettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * シーケンス実行日設定 取得API
         * @summary シーケンス実行日設定 取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionDaySetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/execution_day_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * シーケンス実行日設定 更新API
         * @summary シーケンス実行日設定 更新API
         * @param {ExecutionDaySetting} [executionDaySetting] 実行日設定更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchExecutionDaySetting: async (executionDaySetting?: ExecutionDaySetting, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/execution_day_setting`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(executionDaySetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExecutionDaySettingApi - functional programming interface
 * @export
 */
export const ExecutionDaySettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExecutionDaySettingApiAxiosParamCreator(configuration)
    return {
        /**
         * シーケンス実行日設定 取得API
         * @summary シーケンス実行日設定 取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExecutionDaySetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetExecutionDaySetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExecutionDaySetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * シーケンス実行日設定 更新API
         * @summary シーケンス実行日設定 更新API
         * @param {ExecutionDaySetting} [executionDaySetting] 実行日設定更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchExecutionDaySetting(executionDaySetting?: ExecutionDaySetting, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchExecutionDaySetting(executionDaySetting, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ExecutionDaySettingApi - factory interface
 * @export
 */
export const ExecutionDaySettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExecutionDaySettingApiFp(configuration)
    return {
        /**
         * シーケンス実行日設定 取得API
         * @summary シーケンス実行日設定 取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExecutionDaySetting(options?: any): AxiosPromise<GetExecutionDaySetting200Response> {
            return localVarFp.getExecutionDaySetting(options).then((request) => request(axios, basePath));
        },
        /**
         * シーケンス実行日設定 更新API
         * @summary シーケンス実行日設定 更新API
         * @param {ExecutionDaySetting} [executionDaySetting] 実行日設定更新リクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchExecutionDaySetting(executionDaySetting?: ExecutionDaySetting, options?: any): AxiosPromise<void> {
            return localVarFp.patchExecutionDaySetting(executionDaySetting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExecutionDaySettingApi - interface
 * @export
 * @interface ExecutionDaySettingApi
 */
export interface ExecutionDaySettingApiInterface {
    /**
     * シーケンス実行日設定 取得API
     * @summary シーケンス実行日設定 取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutionDaySettingApiInterface
     */
    getExecutionDaySetting(options?: AxiosRequestConfig): AxiosPromise<GetExecutionDaySetting200Response>;

    /**
     * シーケンス実行日設定 更新API
     * @summary シーケンス実行日設定 更新API
     * @param {ExecutionDaySetting} [executionDaySetting] 実行日設定更新リクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutionDaySettingApiInterface
     */
    patchExecutionDaySetting(executionDaySetting?: ExecutionDaySetting, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for patchExecutionDaySetting operation in ExecutionDaySettingApi.
 * @export
 * @interface ExecutionDaySettingApiPatchExecutionDaySettingRequest
 */
export interface ExecutionDaySettingApiPatchExecutionDaySettingRequest {
    /**
     * 実行日設定更新リクエストボディ
     * @type {ExecutionDaySetting}
     * @memberof ExecutionDaySettingApiPatchExecutionDaySetting
     */
    readonly executionDaySetting?: ExecutionDaySetting
}

/**
 * ExecutionDaySettingApi - object-oriented interface
 * @export
 * @class ExecutionDaySettingApi
 * @extends {BaseAPI}
 */
export class ExecutionDaySettingApi extends BaseAPI implements ExecutionDaySettingApiInterface {
    /**
     * シーケンス実行日設定 取得API
     * @summary シーケンス実行日設定 取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutionDaySettingApi
     */
    public getExecutionDaySetting(options?: AxiosRequestConfig) {
        return ExecutionDaySettingApiFp(this.configuration).getExecutionDaySetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * シーケンス実行日設定 更新API
     * @summary シーケンス実行日設定 更新API
     * @param {ExecutionDaySettingApiPatchExecutionDaySettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExecutionDaySettingApi
     */
    public patchExecutionDaySetting(requestParameters: ExecutionDaySettingApiPatchExecutionDaySettingRequest = {}, options?: AxiosRequestConfig) {
        return ExecutionDaySettingApiFp(this.configuration).patchExecutionDaySetting(requestParameters.executionDaySetting, options).then((request) => request(this.axios, this.basePath));
    }
}
